export interface ITag {
  count: number;
  isSelected: boolean;
  title: string;
  type: ETagType;
}

export enum ETagType {
  /** Придомовая территория **/
  Adjoining_territory = 'adjoining_territory',
  /** Строительство **/
  Construction = 'construction',
  /** Застройщик **/
  Developer = 'developer',
  /** Район **/
  District = 'district',
  /** Отделка **/
  Flat = 'flat',
  /** Дом **/
  House = 'house',
  /** Инфраструктура **/
  Infrastructure = 'infrastructure',
  /** Дети **/
  Kids = 'kids',
  /** управляющая компания **/
  Management_company = 'management_company',
  /** Парковка **/
  Parking = 'parking',
  /** Покупка **/
  Purchase = 'purchase',
  /** Транспортная доступность **/
  Transport_affordable = 'transport_affordable',
}
